import { render, staticRenderFns } from "./TradeAdd.vue?vue&type=template&id=3beb39d0&scoped=true&"
import script from "./TradeAdd.vue?vue&type=script&lang=js&"
export * from "./TradeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beb39d0",
  null
  
)

export default component.exports